import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter , NavLink } from 'react-router-dom';
import s from "./Sidebar.module.scss";
import LinksGroup from "./LinksGroup/LinksGroup.js";
import { changeActiveSidebarItem } from "../../actions/navigation.js";
import Logotime from "../Icons/time.png";
import service from "../../assets/tables/setting-web.svg"
import cn from "classnames";
import BaseAPI from "../../api/apiurl.js"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import door from "../Header/blue-door.gif"
import { FaSignOutAlt } from 'react-icons/fa';


const Sidebar = (props) => {

  const {
    activeItem = '',
    ...restProps
  } = props;

  const [burgerSidebarOpen, setBurgerSidebarOpen] = useState(false)
  const [companyLogo , setCompanyLogo] = useState(' ');
  const [customer, setCustomer] = useState("");
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  function logoutUser() {
   

    localStorage.clear();


    
    window.location.href = '#/login'; // Redirect to the login page
    toggle();
  }


  const headerapi = async () => {
    try {
   
      const company_id = localStorage.getItem('companyid');
      const customer_id = localStorage.getItem('customerid');   
      const response = await fetch(`${BaseAPI}headerapi?company_id=${company_id}&customer_id=${customer_id}`);
      const data = await response.json();
      setCustomer(data.data.customer);
      setCompanyLogo(data.data.customerlogo)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const logoStyle = {
    position: 'absolute',
    bottom: 0,
    width: '200px',
    height: '70px',
  
  };

  const fixedNavStyle = {
    position: 'fixed',
    top: 0,
    left: 230,
    bottom: 0,
    width: '250px', 
  };

  useEffect(() => {
    headerapi();
    if (props.sidebarOpened) {
      setBurgerSidebarOpen(false)
    } else {
      setTimeout(() => {
        setBurgerSidebarOpen(true)
      }, 0);
    }
  }, [props.sidebarOpened])

  // const modules = JSON.parse(localStorage.getItem('modules'));
  const modules = JSON.parse(localStorage.getItem('modules')) || [];  
  const isProjectModuleEnabled = modules.some(module => module.P === 1);
  const isServiceDashboardModuleEnabled = modules.some(module => module.S === 1);
  const userRole = localStorage.getItem('role');

  return (
    <nav className={cn(s.root, {[s.sidebarOpen]: burgerSidebarOpen})} style={fixedNavStyle} >
    {/* // <nav className= {s.root}> */}
    
     <div style={{ textAlign: "center" }}>
  <img
    src={`data:image/png;base64,${companyLogo}`}
    alt="Customer Logo"
    width="80"
    height="60"
    style={{ borderRadius: "50%" }}
  />
  <br />
  <span style={{ color: '#0D2CA9', fontFamily: 'Times New Roman', fontSize: '14px', fontWeight: 'bold', textAlign: "center" }}>{customer}</span>
</div>

<hr style={{ margin: "20px 0" }} />

      <ul className={s.nav}>
      {isProjectModuleEnabled && (
        <LinksGroup
          onActiveSidebarItemChange={activeItem => props.dispatch(changeActiveSidebarItem(activeItem))}
          activeItem={props.activeItem}
          header="Projects"
          isHeader
          iconName={<i className={'eva eva-cube-outline'}/>}
          link="/timeinlive/uielements"
          index="uielements"
          childrenLinks={[
            {
              header: 'Project', link: '/timeinlive/project',
            },
            {
              header: 'Task', link: '/timeinlive/task',
            },
            {
              header: 'Audit', link: '/timeinlive/Complaints',
            },
          ]}
        />
        )}
      {/* {isProjectModuleEnabled && (
        <LinksGroup
          onActiveSidebarItemChange={activeItem => props.dispatch(changeActiveSidebarItem(activeItem))}
          activeItem={props.activeItem}
          header="Projects Dashboard"
          isHeader
          iconName={<i className={'eva eva-home-outline'}/>}
          link="/timeinlive/dashboard"
          index="dashboard"
        />
        )} */}
 {isServiceDashboardModuleEnabled && (
        <LinksGroup
          onActiveSidebarItemChange={activeItem => props.dispatch(changeActiveSidebarItem(activeItem))}
          activeItem={props.activeItem}
          header="Service"
          isHeader
          iconName={<i className={'eva eva-settings'}/>}
          link="/timeinlive/uielements"
          index="uielements"
          childrenLinks={[
            {
              header : 'Product', link: '/timeinlive/product',
            },
            // {
            //   header: 'Closed Service', link: '/timeinlive/closedservices',
            // },
            {
              header: 'Service', link: '/timeinlive/service',
            },
          ]}
        />
        )}

        {/* {isServiceDashboardModuleEnabled && (
        <LinksGroup
          onActiveSidebarItemChange={activeItem => props.dispatch(changeActiveSidebarItem(activeItem))}
          activeItem={props.activeItem}
          header="Service Dashboard"
          isHeader
          iconName={<i className={'eva eva-browser'}/>}
          link="/timeinlive/serviceDashboard"
          index="dashboard"
        />
        )} */}
        

{userRole === 'A' && (
    <LinksGroup
          onActiveSidebarItemChange={activeItem => props.dispatch(changeActiveSidebarItem(activeItem))}
          activeItem={props.activeItem}
          header="User"
          isHeader
          iconName={<i className={'eva eva-people'}/>}
          link="/timeinlive/User"
          index="typography"
        />
        )}
      </ul>

      <div style={{ position: 'relative', bottom: '20px', width: '100%', textAlign: 'center' }}>
  <button
    onClick={() => setModal(true)}
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '5px 10px',
      borderRadius: '50px',
      border: 'none',
      backgroundColor: 'white',
      color: 'black',
      fontWeight: 'bold',
      cursor: 'pointer',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, Helvetica, sans-serif',
      transition: 'color 0.3s', // Add transition for a smooth color change
    }}
    onMouseEnter={(e) => e.target.style.color = 'red'} 
    onMouseLeave={(e) => e.target.style.color = 'black'} 
  >
    <FaSignOutAlt style={{ marginRight: '5px' }} />
    Logout
  </button>
</div>

    <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Logout Confirmation</ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: "red", fontWeight: "bold" }}>Are you sure you want to logout?</p>
            <img
              src={door} // Replace with the URL of your GIF
              alt="Logout GIF"
              width="30%"
              style={{ display: "block", margin: "0 auto" }}
            />
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button color="secondary" onClick={toggle}>
          Cancel
          </Button>
          <Button color="danger" onClick={logoutUser}>
          Logout 
          </Button>
        </ModalFooter>
      </Modal>

      <img src={Logotime} alt="My logo" style={logoStyle} width="200" 
     height="70"  /> 
    </nav>
  );
}


Sidebar.propTypes = {
  sidebarOpened: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  activeItem: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
}

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
    activeItem: store.navigation.activeItem,
  };
}

export default withRouter(connect(mapStateToProps)(Sidebar));
